<template>
  <div class="receptionPage" @click="handleFullscreen">
    <h2 class="wechatScanLabel" v-if="showLabelTitle">打开微信，扫一扫</h2>
    <div class="content">
      <div class="leftContent">
        <div class="privateQrCodeWrap" v-if="showCate== 'privateAd'">
          <div class="qrcodeSurvey">
            <img :src="privateUrl"  alt="扫码操作"/>
          </div>
          <!-- <p class="wechatName">叶医生</p> -->
          <div class="scanSurvey" v-if="showCate== 'paySuccess'">
            <h2>扫描二维码、填写问卷</h2>
            <h2>即可领取20元抵现券</h2>
            <h2>用于免费查看电子影像和报告</h2>
          </div>
        </div>
        <div class="recordPatientInfo showInfoText" v-if="showCate =='patientRegister'">
          <p class="patientName">姓名：<span>{{hiddenName(registerPatient.name)}}</span></p>
          <p>性别：{{registerPatient.gender || ''}}</p>
          <p>生日：{{registerPatient.birthDate || ''}}</p>
          <p class="focusOn">关注“同心互联网医院”公众号，</p>
          <p>完成线上报到，获取免费电子影像和报告。</p>
        </div>
        <div class="payInfo" v-if="showCate== 'waitPay' || showCate == 'paySuccess'">
          <h2 class="payLabel" >
            <span :class="{paySucess: payInfo.title== '支付成功'}">{{payInfo.title || '支付成功'}}</span>
          </h2>
          <div class="payLabelImage">
            <img src="https://webimage.tongxinyiliao.com/ris/images/payLabelImage.png"/>
          </div>
          <div class="showInfoText">
            <p class="payName">姓名：<span>{{hiddenName(payInfo.name)}}</span></p>
            <p>电话：{{hiddenPhone(payInfo.phone)}}</p>
            <p>总收费：<span class="totalFee">{{payInfo.totalAmount}}元</span></p>
          </div>
        </div>
      </div>
      <div class="rightContent">
        <div class="operationImageWrap" v-if="showCate =='privateAd'"></div>
        <div class="publicQrCodeWrap" v-if="showCate =='patientRegister'">
          <div class="qrcodeSurvey">
            <img :src="'https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=' + registerPatient.qrCode || ''"  alt="扫码操作"/>
          </div>
          <p class="wechatName">同心互联网医院</p>
        </div>
        <div class="payImage" v-if="showCate== 'waitPay'">
          <div :style="curHeight <= 480 ? 'margin-top: 4%;' : 'margin-top: 15%;'" class="zhiFuBaoPayBg" v-if="payInfo.payType==='线上-支付宝'">
            <img class="head" src="https://webimage.tongxinyiliao.com/ris/images/zhifubaoHead.png" alt="">
            <p class="payChannel">同心医联（{{currentCenterName}}）</p>
            <img class="qrCode" :src="payInfo.payUrl"  alt="扫码操作"/>
            <img class="footer" src="https://webimage.tongxinyiliao.com/ris/images/zhifubaoFooter.png" alt="">
          </div>
          <div :style="curHeight <= 480 ? 'margin-top: 6%;' : 'margin-top: 18%;'" class="weiXinPayBg" v-if="payInfo.payType==='线上-微信'">
            <img class="head" src="https://webimage.tongxinyiliao.com/ris/images/wechatHead.png" alt="">
            <p class="payChannel">同心医联（{{currentCenterName}}）</p>
            <img class="qrCode" :src="payInfo.payUrl"  alt="扫码操作"/>
            <img class="footer" src="https://webimage.tongxinyiliao.com/ris/images/wechatFooter.png" alt="">
          </div>
        </div>
        <div class="privateQrCodeWrap" style="margin-top:24px" v-if="showCate== 'paySuccess'">
          <div class="qrcodeSurvey"  style="flex:2;">
            <img :src="privateUrl"  alt="扫码操作"/>
          </div>
          <!-- <p class="wechatName">叶医生</p> -->
          <div class="scanSurvey" style="flex:1;margin-bottom:24px">
            <h2>扫描二维码、填写问卷</h2>
            <h2>即可领取20元抵现券</h2>
            <h2>用于免费查看电子影像和报告</h2>
          </div>
        </div>
      </div>
    </div>
    <div class="surveyWarp" v-if="showCate== 'privateAd'">
      <div class="survey" v-if="showCate== 'privateAd'">
        <h2>扫描二维码、填写问卷</h2>
        <h2>即可领取20元抵现券，用于免费查看电子影像和报告</h2>
      </div>
    </div>
  </div>
</template>
<script>
import Bus from '../../libs/bus'
import QRCode from 'qrcode'
import { mapState } from 'vuex'
import { getSession, toast } from '../../libs/utils'
import { findLast } from 'lodash'
export default {
  data () {
    return {
      showCate: 'privateAd',
      payInfo: {},
      registerPatient: {},
      expireTime: 0,
      timer: null,
      privateUrl: '',
      wechatMediaCode: '',
    }
  },
  computed: {
    ...mapState({
      currentCenterId: state => state.app.currentCenterId,
      currentCenterName: state => state.app.currentCenterName
    }),
    showLabelTitle(){
      if (this.showCate == 'privateAd' || this.showCate == 'patientRegister') return true
      return false
    },
  },
  created () {
    this.curHeight = document.body.clientHeight
    Bus.$on('onlieRegistrationPay', async (data) => {
      if (!data || !data.type) return false
      if (data.type === 'pay') {
        if (data.title && data.title === '欢迎扫码支付') {
          this.showCate = 'waitPay'
          if (data.qrcode) data.payUrl = await QRCode.toDataURL(data.qrcode)
        }
        if (data.title && data.title !== '欢迎扫码支付') {
          this.showCate = 'paySuccess'
        }
        this.payInfo = data
      }
      if (data.type === 'reception') {
        this.showCate = 'patientRegister'
        this.registerPatient = data
      }
    })
  },
  updated () {
    this.curHeight = document.body.clientHeight
  },
  mounted () {
    this.getPrivateUrl()
  },
  methods: {
    handleFullscreen () {
      let main = document.body
      if (this.value) {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
      } else {
        if (main.requestFullscreen) {
          main.requestFullscreen()
        } else if (main.mozRequestFullScreen) {
          main.mozRequestFullScreen()
        } else if (main.webkitRequestFullScreen) {
          main.webkitRequestFullScreen()
        } else if (main.msRequestFullscreen) {
          main.msRequestFullscreen()
        }
      }
    },
    hiddenName(name) {
      if (!name) return ''
      if (name.length > 2){
        return `${name.substring(0,1)}*${name.slice(-1)}`
      }
      return name
    },
    hiddenPhone(phone) {
      if (!phone) return '暂无'
      return `${phone.substring(0,3)}****${phone.slice(-4)}`
    },
    retPrivateAd (expireTime) {
      if (this.timer) clearInterval(this.timer)
      this.expireTime = expireTime
      this.timer = setInterval(() => {
        if (this.expireTime <= 1) {
          clearInterval(this.timer)
          this.showCate = 'privateAd'
        } else {
          --this.expireTime
        }
      }, 1000)
    },
    getPrivateUrl () {
      let userAuth = getSession('userAuth', 'object') || null
      if (!userAuth) return toast({msg: '您没有权限使用哦'})
      if (!this.currentCenterId) return toast({msg: '请先选择影像中心'})
      let centerVos = userAuth.centerVos || []
      let data = findLast(centerVos, {id: this.currentCenterId})
      if (data.params) {
        try {
          let paramsVal = JSON.parse(data.params)
          this.privateUrl = paramsVal.privateQrCode || ''
          this.wechatMediaCode = paramsVal.wechatMediaCode
        } catch (error) {
          toast({msg: '获取私号二维码异常'})
        }
      }
    }
  },
  watch: {
    showCate (newVal, oldVal) {
      if (newVal === oldVal) return false
      if (newVal === 'paySuccess') return this.retPrivateAd(10)
      if (newVal === 'waitPay' || newVal === 'patientRegister') return this.retPrivateAd(300)
    },
    currentCenterId(newVal, oldVal) {
      if (newVal === oldVal) return false
      this.getPrivateUrl()
    }
  }
}
</script>
<style lang="less">
@import '../../style/common/reset.less';
@import '../../style/common/variable.less';
.ant-layout-header{
  height: 40px;
  line-height: 40px;
  .headerMenu{
    line-height: 40px;
  }
}
.receptionPage{
  height: 100%;
  width: 100%;
  background-color: @baseColor;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .wechatScanLabel{
    padding-top: @SeesawDistance;
    text-align: center;
    font-size: 32px;
    font-weight: 700;
  }
  .surveyWarp{
    text-align: center;
    height: 100px;
    .survey{
      line-height: 1.2;
      h2{
        font-size: @titleFontSize - 3px;
        font-weight: bold;
      }
    }
  }
  .content{
    flex:1;
    display: flex;
    flex-direction: row;
    .leftContent{
      flex:1;
      display: flex;
      align-items: center;
      .showInfoText{
        font-size: @titleFontSize;
        font-weight: 700;
        color: @secondFontColor;
        p{
          padding-top: @LeaveDistance / 2;
        }
        .patientName{
          span{
            font-size: @titleFontSize * 4;
            color: @primaryColor;
          }
        }
        .payName{
          span{
            font-size: @titleFontSize * 2;
            color: @primaryColor;
          }
        }
      }
      .recordPatientInfo{  
        .focusOn{
          padding-top: @LeaveDistance * 2;
        }
      }
      .payInfo{
        .payLabel{
          font-size: 50px;
          font-weight: 700;
          text-align: center;
          .paySucess{
            color:@primaryColor;
          }
        }
        .payLabelImage{
          text-align: center;
          img{
            width: 70%;
            height: auto;
          }
        }
        .showInfoText{
          p{
            padding-left: 12%;
          }
          .totalFee{
            color:@activeColor;
          }
        }
      }
      .privateQrCodeWrap{
        height: 100%;
        display: flex;
        flex-direction: column;
        text-align: center;
        font-size: @titleFontSize;
        position: relative;
        .qrcodeSurvey{
          flex: 1;
          background: url('@{bgImgDomain}/images/qrcodeOneBg.png') no-repeat center center;
          background-size: 100%;
        }
        .wechatName{
          font-size: @titleFontSize - 5px;
        }
        img{
          height: calc(100% - 40%);
          width: calc(100% - 50%);
          position: relative;
          top:58%;
          transform:translateY(-50%);
          object-fit: contain;
        }
        .scanSurvey{
          h2{
            font-size: @titleFontSize - 10px;
          }
        }
      }
    }
    .rightContent{
      flex: 1;
      .operationImageWrap{
        height: 100%;
        width: 100%;
        background: url('@{bgImgDomain}/images/imageReportView.png') no-repeat center center;
        background-size: 90%;
      }
      .publicQrCodeWrap{
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        text-align: center;
        font-size: @titleFontSize;
        .qrcodeSurvey{
          flex: 1;
          background: url('@{bgImgDomain}/images/qrcodeOneBg.png') no-repeat center center;
          background-size: contain;
          z-index: 1;
        }
        .wechatName{
          font-size: @titleFontSize - 5px;
        }
        img{
          height: calc(100% - 50%);
          width: calc(100% - 50%);
          position: relative;
          top:58%;
          transform:translateY(-50%);
          object-fit: contain;
        }
      }
      .payImage{
        height: 100%;
        text-align: center;
        .zhiFuBaoPayBg{
          text-align: center;
          margin: 5% 20%;
          display: flex;
          flex-direction: column;
          .head{
            width: 100%;
          }
          .footer{
            width: 100%;
          }
          .qrCode{
            border:4px solid #72d3fb;
            border-radius: 10px;
            margin: 0 auto;
          }
          .payChannel{
            font-size: @titleFontSize - 10px;
            color: #434343;
          }
        }
        .weiXinPayBg{
          text-align: center;
          margin: 5% 20%;
          display: flex;
          flex-direction: column;
          .head{
            width: 100%;
          }
          .footer{
            width: 100%;
          }
          .qrCode{
            border:4px solid #72d3fb;
            border-radius: 10px;
            margin: 0 auto;
          }
          .payChannel{
            font-size: @titleFontSize - 10px;
            color: #434343;
          }
        }
        // img{
        //   width: 200px;
        //   height: 200px;
        //   position: absolute;
        //   left: 50%;
        //   top:49%;
        //   transform: translate(-50%, -50%);
        //   border-radius: 10px;
        // }
      }
      .privateQrCodeWrap{
        height: 100%;
        display: flex;
        flex-direction: column;
        text-align: center;
        font-size: @titleFontSize;
        position: relative;
        .qrcodeSurvey{
          flex: 1;
          background: url('@{bgImgDomain}/images/qrcodeOneBg.png') no-repeat center center;
          background-size: contain;
        }
        .wechatName{
          font-size: @titleFontSize;
          margin-bottom: 20px;
        }
        img{
          height: calc(100% - 40%);
          width: calc(100% - 50%);
          position: relative;
          top:58%;
          transform:translateY(-50%);
          object-fit: contain;
        }
      }
    }
  }
}
</style>